// module imports
import DtmfPlayer from 'modules/Audio/DtmfPlayer'
import { getActiveSession } from 'modules/Sip/Helpers'
// constant imports
import { DIALPAD, TRANSFER } from 'constants/General'
import { CHARACTER_MAP, SEND_DTMF_INTERTONE_GAP, SEND_DTMF_OPTIONS } from 'constants/Dtmf.constants'
import {
  SEARCH_KEY_FULFILLED,
  SEARCH_KEY_PENDING,
  SEARCH_CLEAR,
} from 'redux/Contacts/constants'
import { isCSV3 } from '../modules/Helpers';

const STOPS = [SEARCH_CLEAR, SEARCH_KEY_FULFILLED]

const dtmfPlayer = new DtmfPlayer()

const DtmfMiddleware = (store) => (next) => (action) => {
  // stop dtmf actions
  if (STOPS.includes(action.type)) {
    dtmfPlayer.stop()
  }

  const { action: dialerAction } = store.getState().sessions

  // disable if transferring
  if (action.type === SEARCH_KEY_PENDING && dialerAction !== TRANSFER) {
    // key mapping
    const key = CHARACTER_MAP[action.meta?.key?.toString().toLowerCase()]
    // if key has map send it
    if (key) {
      // TODO handle merged send to both
      // send key to active session
      const session = getActiveSession(store.getState)

      if (dialerAction === DIALPAD && session?.sendDTMF) {
        session.sendDTMF(key, {
          ...SEND_DTMF_OPTIONS,
          interToneGap: (isCSV3() ? SEND_DTMF_INTERTONE_GAP.cs3 : SEND_DTMF_INTERTONE_GAP.cs2) || undefined,
        })
      }

      dtmfPlayer.play(key)
    }
  }
  // continue on
  next(action)
}

export default DtmfMiddleware
